import { Link } from 'react-router-dom'

interface HeaderProps {
  title?: string
  subtitle?: string
}

export function Header({
  title = 'Lagewerkzeug',
  subtitle = 'Lagebeschreibungen für deutsche Gemeinden'
}: HeaderProps) {
  return (
    <header className="py-6 flex items-center justify-center gap-6">
      {/* gut8 Corporate Design v2 - Header with Logo */}
      <div className="flex items-center gap-6">
        {/* Logo - links to gut8 website */}
        <a
          href="https://wertweisend.net"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-shrink-0 hover:opacity-80 transition-opacity"
        >
          <img
            src="/images/gut8_logo-short.svg"
            alt="gut8"
            className="h-14 w-auto"
          />
        </a>

        {/* Divider */}
        <div className="h-12 w-px bg-text-inverse/30" />

        {/* Title and Subtitle - links to home */}
        <Link to="/" className="flex flex-col items-start hover:opacity-90 transition-opacity">
          <h1 className="text-gut8-xl font-bold text-primary uppercase tracking-wide">
            {title}
          </h1>
          <p className="text-gut8-sm font-normal text-text-inverse/70">
            {subtitle}
          </p>
        </Link>
      </div>
    </header>
  )
}
